<template lang="pug">
    layout
        template(slot="title")

            // Title
            title-component(:title="$t('portfolio.title')" type="h1")

        div
            frequency-component(:frequency="refreshTime" :refreshAction="refreshAction")

        div.mt-5(v-if="!secretKey")
            v-alert(
                border="bottom"
                color="primary"
                elevation="2"
                type="info"
            ) Please add Trading Technologies credentials on Config page

        div.mt-5(v-else-if="!list.length")
            v-alert(
                border="bottom"
                color="red"
                elevation="2"
                type="warning"
            ) Data Connection Unavailable

        div.mt-5(v-else)
            div.marketsTableProgress
                v-progress-linear(
                    v-if="isLoading"
                    indeterminate
                    color="yellow darken-2"
                )

            v-simple-table.c-table
                template(v-slot:default)
                    thead
                        tr
                            th(v-for="field in savedFields") {{ dictionary[field].name }}
                    tbody
                        template(v-if="list.length")
                            tr(v-for="item in list" :key="item.instrumentId" v-if="item")
                                template(v-for="field in savedFields")
                                    td(v-if="dictionary[field].type === 'date'") {{ formatDate(item[field]) }}
                                    td(v-else-if="dictionary[field].type === 'multiply'") {{ (item[field] * item.displayFactor).toFixed(3) }}
                                    td(v-else) {{ item[field] }}
</template>

<script>
    import { Title, Frequency, DataFlow } from '~components';
    import Layout from '../Layout';
    import { mapActions, mapGetters } from 'vuex';
    import { portfolio } from '~api';
    import dayjs from 'dayjs';

    const DEFAULT_FIELDS = ['name', 'lastTradeDate', 'pnl', 'netPosition'];

    export default {
        components: {
            Layout,
            TitleComponent: Title,
            DataFlowComponent: DataFlow,
            FrequencyComponent: Frequency,
        },
        data() {
            return {
                dataList: [],
                isLoading: false,
                savedFields: null,
                dictionary: this.$t('portfolio.fieldsDictionary'),
            };
        },
        computed: {
            ...mapGetters('portfolio', ['refreshTime']),
            ...mapGetters('tt', ['list', 'secretKey']),
        },
        async created() {
            // Get refresh time
            this.isLoading = true;
            this.getRefreshTime();

            this.getSavedPositions();

            await this.getPositions();

            await this.getList();

            const respFields = await portfolio.getPortfolioFields();

            if (respFields.ok)
                this.savedFields = respFields.data.length
                    ? respFields.data
                    : DEFAULT_FIELDS;

            this.isLoading = false;
        },
        methods: {
            ...mapActions('portfolio', ['getRefreshTime']),
            ...mapActions('tt', [
                'getList',
                'getPositions',
                'getSavedPositions',
            ]),

            /**
             * Get data list
             */
            async refreshAction(refresh = false) {
                this.isLoading = true;

                await this.getList(refresh);

                this.isLoading = false;
            },

            /**
             * Date formater
             * @param {string} val
             * @returns {string}
             */
            formatDate(val) {
                return dayjs(val.toString(), 'YYYYMMDD').format('MMM DD YYYY');
            },
        },
    };
</script>

<style lang="stylus" scoped>
    .marketsTable
        td
            width: 50%

    .marketsTableProgress
        height: 15px
</style>
